"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _ChevronDown = _interopRequireDefault(require("@insided/shared/icons/ChevronDown"));

var _dropdownUtils = require("./utils/dropdownUtils");

var _SimpleDropdown = _interopRequireDefault(require("./custom-dropdown/SimpleDropdown"));

var _DropdownList = _interopRequireDefault(require("./custom-dropdown/DropdownList"));

var CustomDropdownMenu = function CustomDropdownMenu(_ref) {
  var children = _ref.children,
      name = _ref.name,
      isHamburgerList = _ref.isHamburgerList;
  var normalized = children.map(function (child) {
    return (0, _dropdownUtils.normalizeCategory)(child);
  });
  var categoryMenuRef = (0, _preact.createRef)();
  var categoryList = normalized; // Use categories directly without flattening

  return (0, _preact.h)(_SimpleDropdown.default, {
    popupName: "custom-dropdown",
    className: "dropdown dropdown--forums-overview",
    openOnHover: false,
    trigger: (0, _preact.h)("span", {
      style: {
        display: 'flex',
        alignItems: 'center'
      },
      className: "main-menu-trigger"
    }, (0, _preact.h)("span", null, name), (0, _preact.h)(_ChevronDown.default, {
      width: 16,
      height: 16
    }))
  }, (0, _preact.h)("li", {
    "aria-hidden": "true",
    className: "arrow is-hidden-S"
  }), (0, _preact.h)("li", {
    className: "main-menu-list--overflow-scroll",
    ref: categoryMenuRef
  }, Boolean(categoryList.length) && (0, _preact.h)(_DropdownList.default, {
    categoryList: categoryList,
    popupName: "custom-dropdown",
    isHamburgerList: isHamburgerList,
    categoryMenuRef: categoryMenuRef
  })));
};

var _default = CustomDropdownMenu;
exports.default = _default;